import * as React from "react";
import { BaseBlock, BaseBlockOptions } from "sb-resp-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { HamburgerNavigationTabSwitcherBlock } from "./HamburgerNavigationTabSwitcherBlock";

import * as LOCALMOCKS from "../../mocks/TabSwitcherMocks";
let _localMocks: typeof LOCALMOCKS;

if (process.env.NODE_ENV === "development") {
    _localMocks = require("../../mocks/TabSwitcherMocks");
}

export class HamburgerNavigationTabSwitcherBlockRoot extends BaseBlock {
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {}
        },
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {
            this.options.dict = BaseDict;
            this.options.cms = _localMocks.CmsMock;
        }

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = {...BaseDict, ...(options.dict || {})};

        // merge default and CMS options
        this.options.cms = {...config, ...(options.cms || {})};
    }

    activate() {
        return super.activate(
            <HamburgerNavigationTabSwitcherBlock dict={this.options.dict} cms={this.options.cms} />
        );
    }
}

window["HamburgerNavigationTabSwitcherBlock"] = HamburgerNavigationTabSwitcherBlockRoot;